module.exports = __webpack_public_path__ + "img/icon-question-rating-group-like.bb6d709f.svg";